import { useIntl } from 'react-intl';
import { getTrailRouteTypeLabel, TrailRouteType } from '@alltrails/trails';
import ExploreServiceFilters from '../../types/ExploreServiceFilters';
import useCheckboxFilterConfig from './useCheckboxFilterConfig';

const routeTypes: TrailRouteType[] = ['O', 'L', 'P'];

export const getValidRouteTypes = (routes: string[]) => routes.filter(route => routeTypes.includes(route as TrailRouteType)) as TrailRouteType[];

const useRouteTypeFilterConfig = (exploreServiceFilters: ExploreServiceFilters, onFiltersChange: (updatedFilters: ExploreServiceFilters) => void) => {
  const intl = useIntl();

  return useCheckboxFilterConfig({
    exploreServiceFilterKey: 'routeType',
    exploreServiceFilters,
    getValueLabel: routeType => getTrailRouteTypeLabel(intl, routeType),
    label: intl.formatMessage({ defaultMessage: 'Route type' }),
    onFiltersChange,
    values: routeTypes
  });
};

export default useRouteTypeFilterConfig;
